module.exports = __webpack_public_path__ + "img/send_postulation.b354dd87.png";